export default {
  simulation: {
    cliente: {
      nombres: '',
      identificacion: '',
      tipoIdentificacion: '',
    }
  },
  disbursementModality: {
    modalidad: {},
    accountType: {},
    financialEntitie: '',
    state: '',
    city: '',
    numeroCuenta: '',
    meansOfDisbursement: {}
  },
  suggestedCustomerSegmentAndType: {
    clientType: {}
  }
}
